// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"153":"sogamList","489":"xmasAdmin","867":"adultRank","971":"pastorSogamList"}[chunkId] + "." + {"153":"c42087ee","489":"087bb108","867":"34789371","971":"541f05f9"}[chunkId] + ".css";
};